<template id="threeTmpl">
  <!-- div style="display: block; height:100%;"-->
  
  <div>
    <div id="infoThreeJs"></div>
    <div id="infoMouseThreeJs" v-if="this.printMouse != null && (this.printMouse == true || this.printMouse == 'true')"></div>
    <div id="container" style="height:500px;"></div>
   
    <!-- POI DETAILS -->
    <dlg-poi-details ref="dlgPoiDetails" :orgid="orgid" :siteid="siteid" :mapDetailObj="mapDetailObj"></dlg-poi-details>
    
  </div>
</template>
<script>
import i18n from '@/i18n';
import {events} from '@/event-bus.js';
import constants from '@/ctConstants.js';
import ctDialogPoiDetails from "@/components/commons/ctDialogPoiDetails.vue";

import * as Three from 'three';
import OrbitControls from 'three-orbitcontrols'
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader';

const CONTROLS_DISTANCE_MIN = 1;
const CONTROLS_DISTANCE_MAX_MULTIPLIER = 2;
const DEFAULT_CAMERA_POS_Z = 3;
const DEFAULT_CAMERA_POS_Y = 1;

export default {
  i18n,
  data: () => ({
    configObj: null,
    container:null,
    camera: null,
    scene: null,
    renderer: null,
    controls: null,
    object: null,
    mainObjScaleValue: 1,
    defaultMaterial: new Three.MeshBasicMaterial({ color: 0x2B7DE9, transparent: true, opacity: 0.5 }),
    //defaultMaterialPoi: new Three.MeshBasicMaterial( {color: 0xffff00, transparent: true, opacity: 0.8} ),
    //defaultGeometryPoi: new Three.SphereGeometry( 0.05, 20, 20),
    //defaultGeometryPoi: new Three.CircleGeometry(  0.10, 32 ),
    defaultGeometryPoi: new Three.BoxGeometry( 0.10, 0.10, 0.10 ),
    raycaster: new Three.Raycaster(), 
    textureLoader: new Three.TextureLoader(),
    poilist: [],
    poiObjList: [],
    cameraVisibleHeight: null,
    cameraVisibleWidth: null,
    repositoryFolder:""
  }),
  props: ['orgid', 'siteid', 'mapDetailObj','printMouse'],
  components: {
    "dlg-poi-details":ctDialogPoiDetails,
  }, 
  mounted() {
    this.init();
  },
  beforeDestroyed() {
    console.log('ctRenderThreejs - beforeDestroyed');
    this.removeListeners();
  },  
  destroyed() {
    console.log('ctRenderThreejs - destroyed');
    this.removeListeners();
  },
  methods: {
    init() {
      //=== REMOVE LISTENERS
      this.removeListeners();

        //=== SETTING CONTAINER
        this.container = document.getElementById('container');
       
        //=== CALCULATE REPOSITORY FOLDERS
        var appBasePath = this.$router.options.base;
        if(process.env.NODE_ENV === 'production'){
          this.repositoryFolder = appBasePath + constants.ENDPOINT_REPOSITORY_THREEJS;
          //this.repositoryFolder = constants.ENDPOINT_REPOSITORY_THREEJS;
        } else {
          this.repositoryFolder = appBasePath + constants.ENDPOINT_REPOSITORY_THREEJS;
          //this.repositoryFolder = constants.ENDPOINT_REPOSITORY_THREEJS;
        }
        console.log("repositoryFolder:" + this.repositoryFolder);

        //=== CARICO LA CONFIGURAZIONE 
        if(!this.isEmptyObj(this.mapDetailObj))
        {
           this.loadInitConfig();
        }
        

        //=== SETTING DIMENSION
        var myWidth =  window.innerWidth;
        var myHeight =  window.innerHeight;

        //=== SETTING CAMERA
        // https://threejs.org/docs/#api/en/cameras/PerspectiveCamera
        this.camera = new Three.PerspectiveCamera(45, myWidth / myHeight, 1, 1000);
        this.camera.position.y = DEFAULT_CAMERA_POS_Y;
        this.camera.position.z = DEFAULT_CAMERA_POS_Z;
        
        //=== CALCOLO DIMENSIONI CAMERA
        this.calculateCameraVisibleDimensions();
  
        //=== CREATE SCENE
        this.scene = new Three.Scene();

        //=== PAVIMENTO
        var grid = new Three.GridHelper(constants.THREEJS_FLOOR_GRID_SIZE, constants.THREEJS_FLOOR_GRID_DIVISION, 0xffffff, 0xffffff );
        grid.material.opacity = 0.2;
        grid.material.transparent = true;
        this.scene.add( grid );

        //=== SETTING RENDER
        this.renderer = new Three.WebGLRenderer({antialias: true });
        //this.renderer = new Three.WebGLRenderer({antialias: true, canvas: this.container});
        this.renderer.setPixelRatio( window.devicePixelRatio );
        this.renderer.setSize(myWidth, myHeight);
        
        
        //=== SETTING CONTROLS
				this.controls = new OrbitControls( this.camera, this.renderer.domElement );
				//this.controls.addEventListener( 'change', this.render ); // call this only in static scenes (i.e., if there is no animation loop)
				//this.controls.enableDamping = true; // an animation loop is required when either damping or auto-rotation are enabled
				this.controls.dampingFactor = 0.05;
				this.controls.screenSpacePanning = false;
				this.controls.minDistance = CONTROLS_DISTANCE_MIN;
				this.controls.maxDistance = 2;
				this.controls.maxPolarAngle = Math.PI/2;
        //=== AUTOROTATION SPENTO
        // this.controls.autoRotate = true

        //=== APPEND RENDER
        this.container.appendChild(this.renderer.domElement);

        //=== LISTENER
        this.addListeners();
        
        //=== ANIMATE
        this.animate();
  
    },
    animate() 
    {
        requestAnimationFrame(this.animate);
        //controls.update(); // only required if controls.enableDamping = true, or if controls.autoRotate = true
        this.renderer.render(this.scene, this.camera);
    },
    calculateCameraVisibleDimensions()
    {
      // === CALCOLO DIMENSIONI CAMERA
      var vFOV = Three.Math.degToRad( this.camera.fov ); // convert vertical fov to radians
      this.cameraVisibleHeight = 2 * Math.tan( vFOV / 2 ) * this.camera.position.z; // visible height
      this.cameraVisibleWidth = this.cameraVisibleHeight * this.camera.aspect;           // visible width
    },
    getMousePositionVector()
    {
      //=== CALCOLO XY DEL MOUSE
      var mouseX =  ( event.clientX / window.innerWidth ) * 2 - 1;
      var mouseY = - ( event.clientY / window.innerHeight ) * 2 + 1;
     
      var vector = new Three.Vector2( mouseX, mouseY );
      return vector;
    },
    getMousePositionVector3()
    {
      //=== CALCOLO XY DEL MOUSE
      var mouseX =  ( event.clientX / window.innerWidth ) * 2 - 1;
      var mouseY = - ( event.clientY / window.innerHeight ) * 2 + 1;
     
      var vector = new Three.Vector3( mouseX, mouseY, this.camera.near );
      return vector;
    },
    getTouchPositionVector()
    {
      //=== CALCOLO XY DEL TOUCH
      var touchX =  (event.changedTouches[0].clientX / window.innerWidth) * 2 - 1;
      var touchY = -(event.changedTouches[0].clientY / window.innerHeight) * 2 + 1;
     
      var vector = new Three.Vector2( touchX, touchY );
      return vector;
    },
    removeListeners()
    {
        console.log('ctRenderThreejs - removeListeners');
        window.removeEventListener('resize',this.onWindowResize, false);
        window.removeEventListener('mousemove', this.onDocumentMouseMove, false);
        window.removeEventListener('click', this.onDocumentClick, false);
        window.removeEventListener('touchstart', this.onDocumentTouch, false);
    },
    addListeners()
    {
        
        window.addEventListener('resize',this.onWindowResize, false);
        window.addEventListener('mousemove', this.onDocumentMouseMove, false);
        window.addEventListener('click', this.onDocumentClick, false);
        window.addEventListener('touchstart', this.onDocumentTouch, false);
    },
    onWindowResize() 
    {
        //=== SETTING DIMENSION
        var myWidth =  window.innerWidth;
        var myHeight =  window.innerHeight;

        this.camera.aspect = myWidth / myHeight;
				this.camera.updateProjectionMatrix();
				this.renderer.setSize(myWidth, myHeight);
        this.calculateCameraVisibleDimensions();
		},
    onDocumentMouseMove(event) 
    {
        
        //=== CALCOLO XY DEL MOUSE
        var mouseVector = this.getMousePositionVector();
        //var mouseVector3 = this.getMousePositionVector3();

       
        //=== RAYCASTER
        //if(this.printMouse != null && (this.printMouse == true || this.printMouse == 'true'))
        //{
        //  document.getElementById('infoMouseThreeJs').innerHTML = JSON.stringify(mouseVector3);
        //} 
        this.raycaster.setFromCamera(mouseVector, this.camera);

        // USO MENO VARIABILI PER OTTIMIZZARE
        //var intersects =  this.raycaster.intersectObjects(this.poiObjList);

        //=== CONTROLLO INTERSEZIONI
        var intersects =  this.raycaster.intersectObjects(this.poiObjList);
        if(intersects.length > 0) 
        {
            document.body.style.cursor = "pointer";
            if (intersects[0] != null && intersects[0].object != null && intersects[0].object.obj != null 
            && intersects[0].object.obj.things != null  && intersects[0].object.obj.things.length > 0 
            && intersects[0].object.obj.things[0] != null && intersects[0].object.obj.things[0].thing_name != null) 
            {
                document.getElementById('infoThreeJs').innerHTML = JSON.stringify(intersects[0].object.obj.things[0].thing_name);
            }  
        } 
        else 
        {
            //console.log('default');
            document.body.style.cursor = "default";
             document.getElementById('infoThreeJs').innerHTML = '';
        }

    },
    onDocumentClick(event) 
    {
        event.preventDefault();
        
        //=== CHECK DIALOG IS OPEN
        var poiDialogIsOpen = false;
        if(!this.isEmptyObj(this.$refs.dlgPoiDetails) && !this.isEmptyObj(this.$refs.dlgPoiDetails.delayedDlgPoiDetailsIsOpen)){
          poiDialogIsOpen = this.$refs.dlgPoiDetails.delayedDlgPoiDetailsIsOpen;
        }
        console.log("Check Poi dialog is open: " + poiDialogIsOpen);

        if(!poiDialogIsOpen) {
          //=== CALCOLO XY DEL MOUSE
          var mouseVector = this.getMousePositionVector();
          
          //=== RAYCASTER
          this.raycaster.setFromCamera(mouseVector, this.camera);

          console.log("=== VECTOR ===");
          console.log(mouseVector);
          console.log("=== MESH POIS ===");
          console.log(this.poiObjList);

          //=== CONTROLLO INTERSEZIONI
          var intersects =  this.raycaster.intersectObjects(this.poiObjList);
          if (intersects.length > 0) {
              intersects[0].object.callback(intersects[0].object.obj);
          }
        }
    },
    onDocumentTouch(event) 
    {
        event.preventDefault();

        //=== CHECK DIALOG IS OPEN
        var poiDialogIsOpen = false;
        if(!this.isEmptyObj(this.$refs.dlgPoiDetails) && !this.isEmptyObj(this.$refs.dlgPoiDetails.delayedDlgPoiDetailsIsOpen)){
          poiDialogIsOpen = this.$refs.dlgPoiDetails.delayedDlgPoiDetailsIsOpen;
        }
        console.log("Check Poi dialog is open: " + poiDialogIsOpen);

        if(!poiDialogIsOpen) {
          //=== CALCOLO XY DEL TOUCH
          var touchVector = this.getTouchPositionVector();
          
          //=== RAYCASTER
          this.raycaster.setFromCamera(touchVector, this.camera);

        
          //=== CONTROLLO INTERSEZIONI
          var intersects =  this.raycaster.intersectObjects(this.poiObjList);
          if (intersects.length > 0) {
              intersects[0].object.callback(intersects[0].object.obj);
          }
        }
    },
    loadInitConfig()
    {
      if(this.isEmptyString(this.orgid))  
      {
        this.$root.setDialogMsg(i18n.t("err.orgSelectedNotValid"));
      } 
      else if(this.isEmptyString(this.siteid))  
      {
        this.$root.setDialogMsg(i18n.t("err.siteSelectedNotValid"));
      }
      else if(this.isEmptyObj(this.mapDetailObj) ||(!this.isEmptyObj(this.mapDetailObj) && this.isEmptyString(this.mapDetailObj.sitemap_id)))  
      {
        this.$root.setDialogMsg(i18n.t('err.mapSelectedNotValid'));
      }
      else 
      {
        //=== GATEWAY
        var endpoint2go = constants.ENDPOINT_GATEWAY_POI_TJS_MAP_CONFIG;
        endpoint2go += "?org=" + this.orgid;
        endpoint2go += "&site=" + this.siteid;
        endpoint2go += "&map=" + this.mapDetailObj.sitemap_id;
        //endpoint2go += "&accessToken=" + this.getUserAccessToken();
        //console.log(endpoint2go);
        //this.$root.genericGetCallEngine(endpoint2go, this.callbackInitConfig, 'err.loadingThreeJsInitConfig');
        this.$root.genericGetAuthenticatedCallEngine(endpoint2go, this.callbackInitConfig, 'err.loadingThreeJsInitConfig');
      }
    },
    callbackInitConfig(responseData)
    {
      if(!this.isEmptyObj(responseData))
			{
        this.configObj = responseData;
      
        //alert("callbackInitConfig");
        //=== CARICO OBJ
        this.startLoadMainObject();
      } 
      else 
      {
        this.$root.setDialogMsg(i18n.t("err.loadingThreeJsInitConfig"));
      }
    },
    startLoadMainObject()
    {
        this.$root.loading = true;

        //var nomeFile = this.mapDetailObj.sitemap_id.toLowerCase()+'.obj';
        var nomeFile = this.mapDetailObj.map_asset;
        
        var loader = new OBJLoader(new Three.LoadingManager(this.mainManagerOnLoad, undefined, undefined));
        loader.setPath(this.repositoryFolder);
        loader.load(nomeFile, this.mainObjLoaderOnLoad, this.objLoaderOnProgress, this.objLoaderOnError);
    }, 
    objLoaderOnProgress()
    {
        //console.log('loaderOnProgress');
        this.$root.loading = true;
    },
    objLoaderOnError(error)
    {
        this.$root.loading = false;
        console.log('loaderOnError:');
        console.log(error);
    },
    mainObjLoaderOnLoad(obj)
    {
        this.$root.loading = false;
        this.object = obj;
    },
    mainManagerOnLoad() 
    {
        this.object.traverse(this.settingChildOfMainObj);

        var maxDimCamera = Math.max(this.cameraVisibleHeight, this.cameraVisibleWidth);
        var minDimCamera = Math.min(this.cameraVisibleHeight, this.cameraVisibleWidth);
        console.log("maxDimCamera: " + maxDimCamera);
        console.log("minDimCamera: " + minDimCamera);
      
        // === CALCOLO DIMENSIONI OGGETTO
        var boundingBox = new Three.Box3().setFromObject(this.object);
        var size = boundingBox.getSize(new Three.Vector3());
        var maxDimObj = Math.max(size.x, size.y);
        console.log("maxDimObj: " + maxDimObj);
        
        // === SETTING SCALA
        //var scaleValue = Math.floor(minDimCamera / maxDimObj);
        this.mainObjScaleValue = minDimCamera / maxDimObj;
        
        console.log("mainObjScaleValue: " + this.mainObjScaleValue);
        this.object.scale.x = this.mainObjScaleValue;
        this.object.scale.y = this.mainObjScaleValue;
        this.object.scale.z = this.mainObjScaleValue;

        console.log("this.object.scale.x: " +  this.object.scale.x);
        console.log("this.object.scale.y: " +  this.object.scale.y);
        console.log("this.object.scale.z: " +  this.object.scale.z);
 
        //=== POSIZIONE OGGETTO
        this.object.position.x = 0;
        this.object.position.y = 0;
        this.object.position.z = 0;  

        this.object.rotation.x = 0;
        this.object.rotation.y = 0;
        this.object.rotation.z = 0;

        //=== OVERRIDE POSIZIONE SCALE ROTATION OGGETTO
        if(!this.isEmptyObj(this.configObj))
        {
            if(!this.isEmptyString(this.configObj.main_obj_pos_x))
            {
              this.object.position.x = this.configObj.main_obj_pos_x;
            }
            if(!this.isEmptyString(this.configObj.main_obj_pos_y))
            {
              this.object.position.y = this.configObj.main_obj_pos_y;
            }
            if(!this.isEmptyString(this.configObj.main_obj_pos_z))
            {
              this.object.position.z = this.configObj.main_obj_pos_z;
            }

            if(!this.isEmptyString(this.configObj.main_obj_scale_x) && this.configObj.main_obj_scale_x != 0)
            {
              this.object.scale.x = this.configObj.main_obj_scale_x;
            }
            if(!this.isEmptyString(this.configObj.main_obj_scale_y) && this.configObj.main_obj_scale_y != 0)
            {
              this.object.scale.y = this.configObj.main_obj_scale_y;
            }
            if(!this.isEmptyString(this.configObj.main_obj_scale_z) && this.configObj.main_obj_scale_z != 0)
            {
              this.object.scale.z = this.configObj.main_obj_scale_z;
            }

            if(!this.isEmptyString(this.configObj.main_obj_rotation_x) && this.configObj.main_obj_rotation_x != 0)
            {
              this.object.rotation.x = this.configObj.main_obj_rotation_x;
            }
            if(!this.isEmptyString(this.configObj.main_obj_rotation_y) && this.configObj.main_obj_rotation_y != 0)
            {
              this.object.rotation.y = this.configObj.main_obj_rotation_y;
            }
            if(!this.isEmptyString(this.configObj.main_obj_rotation_z) && this.configObj.main_obj_rotation_z != 0)
            {
              this.object.rotation.z = this.configObj.main_obj_rotation_z;
            }
        }
        
        //=== AGGIUNGO OGGETTO ALLA SCENA 
        this.scene.add(this.object);

        //=== DISPOSE
        // LIBERA MEMORIA
        this.defaultMaterial.dispose();

        //=== AGGIUSTO CONTROLLI
        this.controls.target = new Three.Vector3(0, 0, 0);
        this.controls.maxDistance = maxDimObj * CONTROLS_DISTANCE_MAX_MULTIPLIER;
        this.controls.saveState();

        //=== CARICO POIS  
        this.loadPoiList();

      },
      settingChildOfMainObj(child)
      {
        if (child.isMesh) 
        {
            child.material = this.defaultMaterial;
        }   
      },
      loadPoiList()
      {
        if(this.isEmptyString(this.orgid))  
        {
          this.$root.setDialogMsg(i18n.t("err.orgSelectedNotValid"));
        } 
        else if(this.isEmptyString(this.siteid))  
        {
          this.$root.setDialogMsg(i18n.t("err.siteSelectedNotValid"));
        }
        else if(this.isEmptyObj(this.mapDetailObj) ||(!this.isEmptyObj(this.mapDetailObj) && this.isEmptyString(this.mapDetailObj.sitemap_id)))  
        {
          this.$root.setDialogMsg(i18n.t('err.mapSelectedNotValid'));
        }
        else 
        {
          var endpoint2go = constants.ENDPOINT_GATEWAY_POI_TJS_LIST;
          endpoint2go += "?org=" + this.orgid;
          endpoint2go += "&site=" + this.siteid;
          endpoint2go += "&map=" + this.mapDetailObj.sitemap_id;
          //endpoint2go += "&accessToken=" + this.getUserAccessToken();
          //console.log(endpoint2go);
          this.$root.genericGetAuthenticatedCallEngine(endpoint2go, this.callbackLoadPoiList, 'err.loadingThreeJsPoisList');
          } 
      },
      callbackLoadPoiList(responseData)
      {
        this.poilist = responseData;
        
        for (var i = 0; i < this.poilist.length; i++ ) 
        {
            var poiObj = this.poilist[i];
            //console.log(poiObj);
            var pathFileTexture = this.repositoryFolder + 'poi/' + poiObj.background_image +'.png';
            
            var poiColor = new Three.Color('#ffffff');
            if(!this.isEmptyObj(poiObj.alert) && (poiObj.alert == 1 || poiObj.alert == '1'))
            {
              poiColor = new Three.Color('#ff0000');
            }
             
            var material = new Three.MeshBasicMaterial({map: this.textureLoader.load(pathFileTexture), color: poiColor});  
            var mesh = new Three.Mesh(this.defaultGeometryPoi, material);
            
            //=== POSIZIONE POI 
            mesh.position.x = poiObj.transform.position.x;
            mesh.position.y = poiObj.transform.position.y;
            mesh.position.z = poiObj.transform.position.z;

            console.log("POI POSITION :"+mesh.position.x+"," +mesh.position.y+","+mesh.position.z);
           
            //=== SCALE POI MESH
            mesh.scale.x = this.getScaleValuePoiSecure(poiObj.transform.scale.x);
            mesh.scale.y = this.getScaleValuePoiSecure(poiObj.transform.scale.y);
            mesh.scale.z = this.getScaleValuePoiSecure(poiObj.transform.scale.z);
          
            console.log("POI ORIGIN :"+poiObj.transform.scale.x+"," +poiObj.transform.scale.y+","+poiObj.transform.scale.z);
            console.log("POI SCALE :"+mesh.scale.x+"," +mesh.scale.y+","+mesh.scale.z);

            //=== SETTING POI OBJECT
            mesh.obj = poiObj

            //=== SETTING CALLBACK FUNCTION
            mesh.callback = this.openDlgThreeJsPoi;

            //=== ADD TO SCENE
            this.scene.add(mesh);

            //=== ADD TO LIST
            this.poiObjList.push(mesh);

            //=== DISPOSE
            // LIBERA MEMORIA
            material.dispose();
            
        }
        
      },
      getScaleValuePoiSecure(input)
      {
          var scale = input;
          if(scale <= 0)
          {
            scale = 1;
          }
          scale = scale * this.mainObjScaleValue;
          if(scale <= 0)
          {
            scale = 1;
          }
          return scale
      },
      openDlgThreeJsPoi(poiObj)
      {
         if(this.isEmptyString(this.orgid))  
        {
          this.$root.setDialogMsg(i18n.t("err.orgSelectedNotValid"));
        } 
        else if(this.isEmptyString(this.siteid))  
        {
          this.$root.setDialogMsg(i18n.t("err.siteSelectedNotValid"));
        }
        else if(this.isEmptyObj(this.mapDetailObj) ||(!this.isEmptyObj(this.mapDetailObj) && this.isEmptyString(this.mapDetailObj.sitemap_id)))  
        {
          this.$root.setDialogMsg(i18n.t('err.mapSelectedNotValid'));
        }
        else 
        {
          // CHIAMATA AL DETTAGLIO
          var endpoint2go = constants.ENDPOINT_GATEWAY_POI_DETAILS;
          endpoint2go += "?org=" + this.orgid;
          endpoint2go += "&site=" + this.siteid;
          endpoint2go += "&map=" + this.mapDetailObj.sitemap_id;
          endpoint2go += "&poi=" + poiObj.poi_id;
          //endpoint2go += "&accessToken=" + this.getUserAccessToken();
          //this.$root.genericGetCallEngine(endpoint2go, this.callbackOpenDlgThreeJsPoi, 'err.loadingPoi');
          //alert(endpoint2go);
          this.$root.genericGetAuthenticatedCallEngine(endpoint2go, this.callbackOpenDlgThreeJsPoi, 'err.loadingPoi');
        }	
      },
      callbackOpenDlgThreeJsPoi(responseData) 
      {
        if(!this.isEmptyObj(responseData))
        {
          if(!this.isEmptyObj(this.$refs.dlgPoiDetails)){
              this.$refs.dlgPoiDetails.openDlgPoiDetails(responseData);
          }
        }
        else 
        {
          this.$root.setDialogMsg(i18n.t("err.loadingPoi"));
        }
      }, 
    },  
}
</script>